import React from 'react';
import { Tabs } from 'antd';
import UploadMultiApprove from './UploadMultiApprove';
import MultiApprove from './MultiApprove';

const { TabPane } = Tabs;

const indexMultiApprove = () => {
  // const [tabSelection, setTabSelection] = useState("1")

  return (
    <div className='mt-3'>
            <section className='content'>
                <div className='container-fluid'>
                    <Tabs
                        // activeKey={tabSelection}
                        // onChange={e => setTabSelection(e)}
                        size="middle"
                        type="card"
                        style={{ marginBottom: 32, }}
                    >
                        <TabPane tab="Multi Approval" key="1">
                          <MultiApprove/>
                        </TabPane>
                        <TabPane tab="Upload Multi Approval" key="2">
                            <UploadMultiApprove/>
                        </TabPane>
                    </Tabs>
                </div>
            </section>
        </div>
  )
}

export default indexMultiApprove